import React from 'react'
import PropTypes from 'prop-types'
import FlexColumn from '../../../../components/molecules/FlexColumn'
import FlexRow from '../../../../components/molecules/FlexRow'
import OpalHeading from '../../../../components/opal/OpalHeading'
import { useFormattingContext } from '../../../../components/organisms/FormattingProvider/FormattingContext'
import LinkCard from '../common/LinkCard'

function SearchResult ({ result }) {
  const { formatter } = useFormattingContext()

  return (
    <LinkCard to={`/denali-ai/chat/${result.threadId}`}>
      <FlexColumn className='gap-sm'>
        <FlexRow>
          <OpalHeading className='font-serif font-size-md'>{result.name}</OpalHeading>
        </FlexRow>
        <FlexRow>
          <span className='font-sans font-size-xs'>Last Activity: {formatter(result.lastActivity, 'since')}</span>
        </FlexRow>
      </FlexColumn>
    </LinkCard>
  )
}

SearchResult.propTypes = {
  result: PropTypes.shape({
    threadId: PropTypes.string,
    name: PropTypes.string,
    lastActivity: PropTypes.string,
    createdDate: PropTypes.string
  })
}

export default SearchResult
